import React from "react";
import { useState } from "react";
// import { useContext } from "react";


const FormCatalogoBibilo = ({catalogo, setCatalogo, setConsultar, setPagina}) => {

  const {txtbuscar} = catalogo;
  const [error, setError] = useState(false);


    const handleCahnge = (e)=>{
      //guardando el state
      setCatalogo({
        ...catalogo,
        [e.target.name] : e.target.value
      });
      setPagina(1);
    }

    const handleSubmit = e => {
      e.preventDefault();

      //validar
      if (txtbuscar.trim() === '') {
        setError(true);
        return;
      }
      setError(false);

      //pasar al componente principal
      setConsultar(true);
    }

  return (
    <form className="mb-2"
    onSubmit = {handleSubmit}
    >
      {error ? (
        <p className="text-danger mb-3">
          <i className="fa fa-exclamation-circle mr-1" aria-hidden="true"></i>
          <b>Escribe un término para buscar.</b>
        </p>
      ) : null}
      <div className="form-row">
        <div className="form-group col-12 col-md-4">
          <label htmlFor="tipo">Buscar por</label>
          <select
          className="form-control"
          id="tipo"
          name="tipo"
          onChange = {handleCahnge}
          >
            <option value="1"> Título</option>
            <option value="2"> Resumen</option>
            <option value="3"> Ambos</option>
          </select>
        </div>
        <div className="form-group col-12 col-md-8">
          <label htmlFor="txtbuscar">Términos a buscar</label>
          <input
          type="text"
          className="form-control"
          id="txtbuscar"
          name="txtbuscar"
          placeholder="Ej. economía, historia, finanzas…"
          onChange = {handleCahnge}
          />
        </div>
      </div>

      <button type="submit" className="btn btn-block btn-primary">
        <i className="fa fa-search mr-2" aria-hidden="true"></i>
        Buscar en el catálogo
      </button>
      <small id="emailHelp" className="form-text text-muted text-right">
        Catálogo de recursos bibliográficos del CCESEN
      </small>
    </form>
  );
};

export default FormCatalogoBibilo;
